import React from "react";
import {
  Datagrid,
  List,
  Loading,
  NumberField,
  TopToolbar,
  DeleteButton,
  EditButton,
  FilterButton,
  FilterForm,
  CreateButton,
  NumberInput,
} from "react-admin";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { CustomExportButton, CustomImportButton } from "../Signet/util";

const RESOURCE = "precious-inlay-pricing";

const useStyles = makeStyles({
  container: {
    width: "100%",
    padding: 0,
  },
});

const PreciousInlayPricingFilters = [
  <NumberInput source="quantity" label="Quantity" key="quantity" />,
  <NumberInput source="width" label="Width" key="width" />,
];

const PreciousInlayPricingListActions = (props) => {
  const classes = useStyles();
  const { permissions } = props;
  const permissionsList = permissions ? permissions.split(",") : [];
  const canImportExport = permissionsList.includes("view_import_export");

  return (
    <TopToolbar className={classes.container}>
      <Box
        display="flex"
        alignItems="flex-end"
        justifyContent="space-between"
        width="100%"
        sx={{ paddingBottom: "14px", paddingTop: "14px" }}
      >
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <FilterForm filters={PreciousInlayPricingFilters} />
        </Box>
        <Box display="flex" alignItems="center" sx={{ gap: "20px" }}>
          {canImportExport && (
            <>
              <CustomImportButton resource={RESOURCE} />
              <CustomExportButton resource={RESOURCE} />
            </>
          )}
          <FilterButton filters={PreciousInlayPricingFilters} />
          {canImportExport && <CreateButton />}
        </Box>
      </Box>
    </TopToolbar>
  );
};

const PreciousInlayPricingList = (props) => {
  const { permissions } = props;

  if (!permissions) return <Loading />;

  return (
    <List
      {...props}
      exporter={false}
      bulkActionButtons={false}
      actions={<PreciousInlayPricingListActions {...props} />}
      sort={{ field: "id", order: "ASC" }}
    >
      <Datagrid rowClick={null}>
        <NumberField source="quantity" label="Quantity" />
        <NumberField source="width" label="Width" />
        <NumberField source="volume_delta" label="Volume Delta" />
        <NumberField source="labor" label="Labor" />
        <NumberField source="silver_markup" label="Silver Markup" />
        <NumberField source="10k_markup" label="10k Markup" />
        <NumberField source="14k_markup" label="14k Markup" />
        <NumberField source="18k_markup" label="18k Markup" />
        <NumberField source="platinum_markup" label="Platinum Markup" />
        <NumberField source="palladium_markup" label="Palladium Markup" />
        <EditButton />
        <DeleteButton label="" undoable={false} />
      </Datagrid>
    </List>
  );
};

export default PreciousInlayPricingList;
